import {
  configuredYoutubePlaceholderSlider,
  configuredYoutubeSlider,
  configuredYoutubeVideo,
  displayableYoutubeSlider,
} from "../app/media";
import { createYoutubePlayer } from "./youtube-player";
import { initVillancicosRevealAnimation } from "./reveal-on-view";

function createSlide(video, coordinator) {
  const slide = document.createElement("div");
  slide.className = "swiper-slide villancicos-slide";

  const article = document.createElement("article");
  article.className = "villancicos-mini";
  article.setAttribute("aria-label", video.title);

  const playerElement = document.createElement("div");
  playerElement.className = "youtube-player villancicos-player";
  article.append(playerElement);
  slide.append(article);

  let player;
  player = createYoutubePlayer(playerElement, video, {
    onPlay: () => coordinator.activate(player),
    onStop: () => coordinator.release(player),
  });
  coordinator.register(player);

  return { slide, player };
}

function createPlaceholderSlide(title) {
  const slide = document.createElement("div");
  slide.className = "swiper-slide villancicos-slide";

  const article = document.createElement("article");
  article.className = "villancicos-mini villancicos-mini--placeholder";
  article.setAttribute("aria-label", `${title}. Contenido pendiente de aprobación.`);
  slide.append(article);

  return {
    slide,
    player: {
      reset() {},
    },
  };
}

async function initSlider(section, config, coordinator) {
  const sliderElement = section?.querySelector("[data-villancicos-slider]");
  const slidesElement = section?.querySelector("[data-villancicos-slides]");
  const title = section?.querySelector("[data-villancicos-title]");
  const previous = section?.querySelector("[data-villancicos-previous]");
  const next = section?.querySelector("[data-villancicos-next]");
  const pagination = section?.querySelector("[data-villancicos-pagination]");

  if (
    !section
    || section.hidden
    || !sliderElement
    || !slidesElement
    || !title
    || !previous
    || !next
    || !pagination
    || !displayableYoutubeSlider(config)
  ) return null;

  section.hidden = true;
  const videos = Array.isArray(config.videos)
    ? config.videos.filter(configuredYoutubeVideo)
    : [];
  title.textContent = config.title;
  const entries = videos.length > 0
    ? videos.map((video) => createSlide(video, coordinator))
    : Array.from(
      { length: Math.min(config.placeholderSlides, 5) },
      () => createPlaceholderSlide(config.title),
    );
  slidesElement.replaceChildren(...entries.map(({ slide }) => slide));

  try {
    const { mountVillancicos } = await import(
      /* webpackChunkName: "villancicos" */ "./villancicos-swiper"
    );
    section.hidden = false;
    section.dataset.villancicosState = "ready";
    mountVillancicos({
      sliderElement,
      previous,
      next,
      pagination,
      title: config.title,
      entries,
    });
    initVillancicosRevealAnimation(section);

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((observations) => {
        if (observations.some((observation) => !observation.isIntersecting)) {
          entries.forEach(({ player }) => player.reset());
        }
      });
      observer.observe(section);
    }
    return section;
  } catch {
    section.hidden = true;
    section.dataset.villancicosState = "error";
    return null;
  }
}

export async function initVillancicos(config, coordinator) {
  const sections = Array.from(document.querySelectorAll("[data-villancicos-section]"));
  const configByKey = configuredYoutubeSlider(config)
    || configuredYoutubePlaceholderSlider(config)
    ? { villancicos: config }
    : config;

  return Promise.all(sections.map((section) => {
    const key = section.dataset.videoSliderKey || "villancicos";
    return initSlider(section, configByKey?.[key], coordinator);
  }));
}
